import { useEffect } from "react"
import { UNINITIALIZED } from "constants/index"
import { useLazyGetCloseFriendsQuery } from "appRedux/slices/userApiSlice"

export default function useCloseFriends() {
  const [triggerGetCloseFriends, getCloseFriendsResult] = useLazyGetCloseFriendsQuery()

  useEffect(() => {
    fetchCloseFriends()
  }, [])

  function fetchCloseFriends() {
    triggerGetCloseFriends()
  }

  return {
    closeFriends: getCloseFriendsResult?.status !== UNINITIALIZED ? getCloseFriendsResult?.data?.users || [] : null,
    isFetching: getCloseFriendsResult.isFetching,
    isError: getCloseFriendsResult.isError
  }
}
